
<div
    id="contentLibraryItemDetails"
    class="agpr-contentLibraryItemDetails"
>
    @if (selectedItem) {
        <div
            id="contentLibraryItemDetails_container"
            class="agpr-contentLibraryItemDetails-container"
        >
            <div
                id="contentLibraryItemDetails_header"
                class="agpr-contentLibraryItemDetails-header"
            >
                <div
                    id="contentLibraryItemDetails_thumbnail"
                    class="agpr-contentLibraryItemDetails-thumbnail-wrapper"
                >
                    @if ((selectedItem?.url && (selectedItem?.mimeType === 'image/png' || selectedItem?.mimeType === 'image/jpeg')) && !hasError) {
                        <img
                            #thumbnail
                            id="contentLibraryItemDetails_thumbnail_image"
                            class="agpr-contentLibraryItemDetails-thumbnail"
                            [src]="selectedItem.url"
                            [alt]="selectedItem.name"
                            (load)="getImageDimensions($event)"
                            (error)="hasError = true"
                        >
                    } @else {
                        <span
                            id="contentLibraryItemDetails_thumbnail_icon"
                            class="agpr-contentLibraryItemDetails-thumbnail-default-icon"
                            [ngClass]="getFileIcon(selectedItem.mimeType)"
                        ></span>
                    }
                </div>
                <div
                    id="contentLibraryItemDetails_basic"
                    class="agpr-contentLibraryItemDetails-basic"
                >
                    <div
                        id="contentLibraryItemDetails_fileName_row"
                        class="agpr-contentLibraryItemDetails-basic-row"
                    >
                        @if (editingMediaId === selectedItem.id) {
                            <agpr-text-input
                                [id]="'contentLibraryItemDetails_fileName_input'"
                                class="agpr-contentLibraryItemDetails-basic-filename-input"
                                [(ngModel)]="editedMediaName"
                                [maxLength]="255"
                                [initialFocus]="true"
                                [selectOnEdit]="true"
                                [bottomMargin]="false"
                                (blur)="saveMedia(selectedItem)"
                                (keyup.enter)="saveMedia(selectedItem)"
                            ></agpr-text-input>
                        } @else {
                            <div
                                id="contentLibraryItemDetails_fileName"
                                class="agpr-contentLibraryItemDetails-basic-filename-text"
                                [agprTooltip]="selectedItem.name"
                                tooltipPosition="top"
                            >
                                {{ selectedItem.name }}
                            </div>
                        }
                        <!-- Edit Button -->
                        <agpr-button
                            [id]="'contentLibraryItemDetails_editName'"
                            class="agpr-contentLibraryItemDetails-basic-edit"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-pen"
                            tooltip="Common.contentLibrary.tooltip.edit"
                            tooltipPosition="top"
                            (click)="editMedia(selectedItem)"
                        ></agpr-button>
                        <!-- Approve Button -->
                        <agpr-button
                            [id]="'contentLibraryItemDetails_approve'"
                            class="agpr-contentLibraryItemDetails-basic-approve"
                            [style]="buttonTypes.icon"
                            (click)="approveMedia(selectedItem)"
                        >
                            <span
                                id="contentLibraryItemDetails_approve_icon"
                                [class]="isApproved() ? 'fa-badge-check fa-solid' : 'fa-badge-check fa-duotone fa-regular'"
                                [agprTooltip]="getApprovalTooltip()"
                                tooltipPosition="top"
                            ></span>
                            @if (selectedItem?.approvedByUserIds?.length) {
                                <span
                                    id="contentLibraryItemDetails_approve_count"
                                    class="agpr-contentLibraryItemDetails-basic-approve-count"
                                >
                                    {{ selectedItem?.approvedByUserIds?.length }}
                                </span>
                            }
                        </agpr-button>
                    </div>
                    <div
                        id="contentLibraryItemDetails_fileSize_row"
                        class="agpr-contentLibraryItemDetails-basic-row"
                    >
                        <span id="contentLibraryItemDetails_dimensions">{{ thumbnailDimensions }}</span>
                        <span id="contentLibraryItemDetails_fileSize">{{ formatFileSize(selectedItem.size) }}</span>
                    </div>
                    <div
                        id="contentLibraryItemDetails_fileType_row"
                        class="agpr-contentLibraryItemDetails-basic-row"
                    >
                        <span id="contentLibraryItemDetails_fileType">{{ fileType }}</span>
                    </div>
                </div>
            </div>
            <div
                id="contentLibraryItemDetails_notes"
                class="agpr-contentLibraryItemDetails-notesWrapper"
            >
                <div
                    id="contentLibraryItemDetails_notes_header"
                    class="agpr-contentLibraryItemDetails-notesHeader"
                >
                    <h3
                        id="contentLibraryItemDetails_notes_label"
                        class="agpr-contentLibraryItemDetails-label"
                    >
                        {{ 'Common.contentLibrary.details.notes' | localize }}
                    </h3>
                    @if (currentUser) {
                        <agpr-button
                            [id]="'contentLibraryItemDetails_addNote'"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="Discover.userNotes.addNote"
                            tooltipPosition="top"
                            (click)="addNote()"
                        ></agpr-button>
                    }
                </div>
                @if (currentUser) {
                    <agpr-user-notes
                        #userNotes
                        [id]="'contentLibraryItemDetails_userNotes'"
                        class="agpr-contentLibraryItemDetails-notes"
                        [currentUser]="currentUser"
                        [userNotes]="_userNotes"
                        [hideAddButton]="true"
                        [scrolling]="false"
                        (notesChanged)="modifyNotes($event)"
                    ></agpr-user-notes>
                }
            </div>
            <div
                id="contentLibraryItemDetails_upload"
                class="agpr-contentLibraryItemDetails-upload"
            >
                @if (preferences) {
                    <div
                        id="contentLibraryItemDetails_uploadedDate_row"
                        class="agpr-contentLibraryItemDetails-upload-row"
                    >
                        <span
                            id="contentLibraryItemDetails_uploadedDate_label"
                            class="agpr-contentLibraryItemDetails-label"
                        >{{ 'Common.contentLibrary.files.filter.uploadedDate' | localize }}</span>
                        <span id="contentLibraryItemDetails_uploadedDate">{{ selectedItem.createdDate | date:preferences.dateFormat}}</span>
                    </div>
                }
                <div
                    id="contentLibraryItemDetails_uploadedBy_row"
                    class="agpr-contentLibraryItemDetails-upload-row"
                >
                    <span
                        id="contentLibraryItemDetails_uploadedBy_label"
                        class="agpr-contentLibraryItemDetails-label"
                    >{{ 'Common.contentLibrary.files.filter.uploadedBy' | localize}}</span>
                    <span id="contentLibraryItemDetails_uploadedBy">{{ selectedItem.uploadedBy }}</span>
                </div>
                <div
                    id="contentLibraryItemDetails_url_row"
                    class="agpr-contentLibraryItemDetails-upload-row"
                >
                    <span
                        id="contentLibraryItemDetails_url_label"
                        class="agpr-contentLibraryItemDetails-label"
                    >{{ 'Common.contentLibrary.details.Url' | localize}}</span>
                    <div
                        id="contentLibraryItemDetails_url_wrapper"
                        class="agpr-contentLibraryItemDetails-url"
                    >
                        <a
                            id="contentLibraryItemDetails_url"
                            href="{{ selectedItem.url }}"
                            target="_blank"
                            class="agpr-contentLibraryItemDetails-url-text"
                        >{{ selectedItem.url }}</a>
                        <agpr-button
                            [id]="'contentLibraryItemDetails_url_copy'"
                            class="agpr-contentLibraryItemDetails-url-copy"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-copy"
                            tooltip="Common.contentLibrary.tooltipis.copy"
                            tooltipPosition="top"
                            (click)="copyUrl($event, selectedItem.url)"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        </div>
    }

    <ng-template #actionButtons>
        <agpr-button
            [id]="'contentLibraryItemDetails_download'"
            label="Common.contentLibrary.download"
            [style]="buttonTypes.tertiary"
            (click)="downloadMedia(selectedItem, $event)"
        ></agpr-button>
    </ng-template>
</div>
